import { Component,EventEmitter,Optional} from '@angular/core';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { Router } from '@angular/router';
import { AccChequeBookRequestFormHelper,AccChequeBookRequestFormState} from './acc-cheque-book-request-form.helper';
import { BaseFpxFormComponent,ValidatorService } from '@fpx/core'; 
import { ChequebookrequestService } from '../chequebookrequest-service/chequebookrequest.service';
import { Chequebookrequest } from '../chequebookrequest-service/chequebookrequest.model';

 
@Component({
 selector: 'app-acc-cheque-book-request-form',
  templateUrl: './acc-cheque-book-request-form.component.html',
  styleUrls: ['./acc-cheque-book-request-form.component.scss'],
  providers: [
    AccChequeBookRequestFormHelper,
    ChequebookrequestService
  ]
  })

export class AccChequeBookRequestFormComponent extends BaseFpxFormComponent<AccChequeBookRequestFormHelper, AccChequeBookRequestFormState> {
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public accChequeBookRequestFormHelper: AccChequeBookRequestFormHelper,
    public chequebookrequestService: ChequebookrequestService,
    private validatorService: ValidatorService
    
  ) {
    super(formBuilder, router,controlContainer, accChequeBookRequestFormHelper);
  }
  
 protected override doPreInit(): void {
   this.addFormControl('noOfChqBooks', '', [Validators.required]    ,[],'change' );			   		 
   this.addFormControl('accountNumber', '', [Validators.required]    ,[],'change' );			   		 
   this.addFormControl('noOfLeaves', '', [Validators.required]    ,[],'change' );	
   this.addFormControl('requestDate', '', [Validators.required]    ,[] );			   		 
   this.addFormControl('dlvryOption', '', [Validators.required]    ,[],'change' );			   		 
   this.addFormControl('dlvryBranch', '', [Validators.required]    ,[] );			   		 
   this.addFormControl('remarks', '',    );			
   this.addFormControl('inventoryNumber', '',  []   ,
          [
            this.validatorService.dataAvailabilityCheck(
              this.embadedFormMode,
              'inventoryNumber',
              this.chequebookrequestService,
              this.dataAvailable$
            ),
          ],'blur',0,true,0);   		 
	this.setDataService(this.chequebookrequestService);
  }
 
}
